<template>
  <modal-dialog
    persistent
    title="Сначала откройте смену"
    v-bind:value="value"
    v-on:input="onInput"
    with-cross
  >
    <form v-on:submit.prevent="onSubmit" class="open-shift-form">
      <div class="open-shift-form__buttons">
        <button
          v-bind:disabled="isAwaitRequest"
          class="open-shift-form__button-submit"
          type="submit">Открыть</button>
        <button
          class="open-shift-form__button-cancel"
          type="button"
          v-on:click="onInput(false)">Отмена</button>
      </div>
    </form>
  </modal-dialog>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue';

/**
 * @description Компонент формы ввода секретного ключа онлайн-чеков.
 * @type {any}
 */
export default {
  components: { ModalDialog },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    onSubmit() {
      this.$emit('submit');
    },
  },
  name: 'OpenShiftModalDialog',
  props: {
    value: { required: true, type: Boolean },
    isAwaitRequest: { required: true, type: Boolean },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.open-shift-form {
  width: 100%;
  background: white;
  &__buttons {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    gap: 15px;
  }
  &__button {
    &-submit {
      @include buttons.btn-blue(100%, 2rem, 1rem);
      &:disabled {
        background-color: var(--unfocus-color);
      }
    }
    &-cancel {
      @include buttons.btn-transparent(100%, 2rem, 1rem);
    }
  }
}
</style>
